import { Flex, Box, Divider, Heading } from '@chakra-ui/react'
import BaseLayout from 'src/layouts/BaseLayout'
import SchoolListCell from 'src/components/SchoolListCell'
import SchoolCell from 'src/components/SchoolCell'
import FullDashboardCell from 'src/components/FullDashboardCell'
import { useParams } from 'react-router-dom'
import { useAuth } from 'src/contexts/AuthContext'
import { motion } from 'framer-motion'

const MotionHeading = motion(Heading)

const HomePage = () => {
  const { id } = useParams()
  const { currentUser, loading } = useAuth()
  if (loading || !currentUser) {
    return (
      <BaseLayout>
        <MotionHeading
          textAlign="center"
          paddingY={90}
          size="lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          backgroundColor="#eee"
        >
          {loading ? 'Please wait...' : 'Please Login First!'}
        </MotionHeading>
      </BaseLayout>
    )
  }
  return (
    <BaseLayout>
      <Flex>
        <Box minWidth={300} maxWidth={300}>
          <SchoolListCell selected={id} />
        </Box>
        <Divider orientation="vertical" marginX={0} />
        {id ? (
          <SchoolCell id={id} />
        ) : (
          <FullDashboardCell fontWeight={300}>Dashboard</FullDashboardCell>
        )}
      </Flex>
    </BaseLayout>
  )
}

export default HomePage
